import { useState } from "react";
import { toast } from "sonner";
import { TextField, parseYoutubeId } from "@/components/admin/fields";

export const TrackForm = ({ initial, onSubmit, submitting, nextRank = 1 }) => {
  const [f, setF] = useState({ rank: nextRank, title: "", artist: "", youtube: initial?.youtube_id || "", ...initial });
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    const youtube_id = f.youtube ? parseYoutubeId(f.youtube) : null;
    if (f.youtube && !youtube_id) return toast.error("Lien YouTube non reconnu.");
    onSubmit({ rank: Number(f.rank), title: f.title, artist: f.artist, youtube_id });
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="track-form">
      <div className="grid grid-cols-[100px_1fr] gap-5">
        <TextField label="Rang *" type="number" min={1} value={f.rank} onChange={set("rank")} required testId="track-form-rank" />
        <TextField label="Titre *" value={f.title} onChange={set("title")} required testId="track-form-title" />
      </div>
      <TextField label="Artiste(s) *" value={f.artist} onChange={set("artist")} required testId="track-form-artist" />
      <TextField label="Lien YouTube" value={f.youtube} onChange={set("youtube")} placeholder="https://www.youtube.com/watch?v=..." testId="track-form-youtube" />
      <button type="submit" disabled={submitting} data-testid="track-form-submit" className="bg-primary text-white font-display uppercase text-lg px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200 disabled:opacity-50">
        Enregistrer
      </button>
    </form>
  );
};
